import { render } from "./EditarUser.vue?vue&type=template&id=16837140"
import script from "./EditarUser.vue?vue&type=script&lang=js"
export * from "./EditarUser.vue?vue&type=script&lang=js"

import "./EditarUser.vue?vue&type=style&index=0&id=16837140&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__